<template>
  <card>
    <b-row>
      <b-col cols="10">
        <b-form class="row" v-on:submit.prevent="doFilter">
          <b-col md="3">
            <el-input class="input-primary" placeholder="Filter By Name" clearable v-model="tableFilter.name"/>
          </b-col>
          <b-col md="1">
            <button type="submit" class="btn btn-primary"><font-awesome-icon icon="search"/> Search</button>
          </b-col>
        </b-form>
      </b-col>
      <b-col cols="2">
        <create-new-data :data-url="'/pengaturan/pelanggan/create'" :clearfix="false"/>
      </b-col>
      <b-col cols="12 mb-1">
        <div class="d-flex align-items-center h-100">
          <el-checkbox v-model="fakeTableFilter.is_active">Active Only</el-checkbox>
        </div>
      </b-col>
    </b-row>
    <paginated-table ref="dataTable" :can-delete="false" :param-no-uuid="true"  :active-url="apiUrl" :data-url="apiUrl" :data-key="dataKey" :data-columns="columns" :data-params="['is_active','name']">
      <template slot="content_customer_category" slot-scope="defaultSlotScope">
        {{defaultSlotScope.rowData.customer_category.name}}
      </template>
      <template slot="content_count_point" slot-scope="defaultSlotScope">
        <i class="badge badge-info">{{defaultSlotScope.rowData.count_point !== null ? defaultSlotScope.rowData.count_point : 0}}</i>
      </template>
      <template slot="content_created_by" slot-scope="defaultSlotScope">
        {{defaultSlotScope.rowData.created_by.name}}
      </template>
      <template slot="content_last_updated_by" slot-scope="defaultSlotScope">
        {{defaultSlotScope.rowData.last_updated_by.name}}
      </template>
    </paginated-table>
  </card>
</template>
<script>
  import { Input, Checkbox } from 'element-ui'
  import PaginatedTable from '@/components/Tables/PaginatedTable'
  import CreateNewData from '@/components/Buttons/CreateNewData'

  export default {
    components: {
      [Input.name]: Input,
      PaginatedTable,
      CreateNewData,
      elCheckbox: Checkbox
    },
    data () {
      return {
        dataKey: 'customer',
        apiUrl: window.AppConfig.apiUrl + 'customer',
        columns: [
          {
            prop: 'count_point',
            label: 'Total Point',
            sortable: true
          },
          {
            prop: 'name',
            label: 'Nama',
            sortable: true
          },
          {
            prop: 'email',
            label: 'Email'
          },
          {
            prop: 'address',
            label: 'Alamat'
          },
          {
            prop: 'phone',
            label: 'Telepon'
          },
          {
            prop: 'customer_category',
            label: 'Kategori'
          },
          {
            prop: 'registered_date',
            label: 'Terdaftar Tanggal'
          },
          {
            prop: 'created_by',
            label: 'Dibuat Oleh'
          },
          {
            prop: 'last_updated_by',
            label: 'Diperbarui Oleh'
          },
          {
            prop: 'created_at',
            label: 'Tanggal Terbit'
          },
          {
            prop: 'isActive',
            label: 'Active',
            minWidth: 20,
            isToggle: true,
            sortable: true
          }
        ],
        fakeTableFilter: {
          is_active: !!this.$route.query.is_active
        },
        tableFilter: {
          is_active: this.$route.query.is_active,
          name: this.$route.query.name
        }
      }
    },
    watch: {
      'fakeTableFilter.is_active' (value) {
        this.tableFilter.is_active = value ? 1 : null
        this.doFilter()
      }
    },
    methods: {
      doFilter () {
        this.$refs.dataTable.doFilter(this.tableFilter)
      },
      getColorStatus (status) {
        if (status === 'Canceled') {
          return 'dark'
        } else if (status === 'Paid') {
          return 'success'
        } else if (status === 'Invoice') {
          return 'primary'
        } else if (status === 'Working') {
          return 'warning'
        } else if (status === 'New') {
          return 'info'
        } else {
          return 'danger'
        }
      }
    },
    mounted () {
      // this.initData().requestCategory()
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/Settings/Customers/Index.vue